export const MFA_VERIFY_FACTOR = "app/MFA/MFA_VERIFY_FACTOR";
export const MFA_RESEND_CODE = "MFA_RESEND_CODE";
export const UPDATE_RESEND_CODE_TIMER =
  "app/VerifyPasscode/UPDATE_RESEND_CODE_TIMER";
export const RESET_SUCCESS_STATE = "app/VerifyPasscode/RESET_SUCCESS_STATE";
export const RESEND_COUNTER_TIME = 60;
export const REMEMBER_DEVICE = "REMEMBER_DEVICE";
export const SUCCESS_MESSAGE = "SUCCESS_MESSAGE";
